import React from 'react';
import { Button } from '../../components/ui/button';
import { ArrowRight } from 'lucide-react';

const ProcessSection = ({ steps, onContactClick }) => (
  <section className="py-20 md:py-24 bg-tp-bg" id="process" data-testid="process-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-2xl md:text-3xl font-display font-semibold text-tp-text mb-4">Comment ça fonctionne</h2>
        <p className="text-tp-text-light max-w-2xl mx-auto">Un processus simple et transparent en 4 étapes</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {steps.map((step, index) => (
          <div key={step.number} className="relative" data-testid={`process-step-${index}`}>
            <div className="text-5xl font-display font-bold text-tp-accent/20 mb-4">{step.number}</div>
            <h3 className="text-lg font-display font-semibold text-tp-text mb-2">{step.title}</h3>
            <p className="text-sm text-tp-text-light leading-relaxed">{step.description}</p>
            {index < steps.length - 1 && (
              <div className="hidden lg:block absolute top-8 right-0 transform translate-x-1/2">
                <ArrowRight className="h-5 w-5 text-tp-border" />
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="text-center mt-12">
        <Button size="lg" onClick={onContactClick} className="bg-tp-primary hover:bg-tp-primary-light text-white">
          Commencer maintenant <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </div>
  </section>
);

export default ProcessSection;
